export default __webpack_public_path__ + "static/media/why-us-1.5ee453fc.jpg";